import { Pagination, PaginationItem, PaginationRenderItemParams, useTheme } from '@mui/material';
import { getPaginationStyles } from '../BlogListPageDefault/BlogListPageDefault.styles';
import TAGSvgIcon from '@shared-components/components/TAGSvgIcon';
import { Maybe } from '@shared-components/types';
export interface IPaginationProps {
  totalBlogs: number;
  countPerPage?: Maybe<number>;
  handlePaginationChangeEvent: (e: React.ChangeEvent<unknown>, page: number) => void;
  currentPage?: number;
  getPageHref?: (page: number) => string;
}
const PaginationNextItem = () => {
  return <>
			Next <TAGSvgIcon icon="ChevronRightFunc" size={32} sx={{
      display: 'inline-block'
    }} data-sentry-element="TAGSvgIcon" data-sentry-source-file="BlogListPagination.tsx" />
		</>;
};
const PaginationPrevioustItem = () => {
  return <>
			<TAGSvgIcon icon="ChevronLeftFunc" size={32} sx={{
      display: 'inline-block'
    }} data-sentry-element="TAGSvgIcon" data-sentry-source-file="BlogListPagination.tsx" />
			Previous
		</>;
};
const isModifiedClick = (event: React.MouseEvent) => event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
const getPaginationRenderItem = (getPageHref?: (page: number) => string) => (params: PaginationRenderItemParams) => {
  const itemComponents = {
    next: PaginationNextItem,
    previous: PaginationPrevioustItem
  };

  // Disabled items keep the native <button> so they stay non-navigable.
  const href = !params.disabled && params.page != null ? getPageHref?.(params.page) : undefined;
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (href && isModifiedClick(event)) {
      return;
    }
    if (href) {
      event.preventDefault();
    }
    params.onClick(event);
  };
  return <PaginationItem slots={itemComponents} {...params} component={href ? 'a' : 'button'} href={href} onClick={handleClick} />;
};
export const getPaginationCount = (totalCount: number, countPerPage?: Maybe<number>) => {
  return Math.ceil(totalCount / (countPerPage ?? 12));
};
export default function BlogListPagination({
  totalBlogs,
  countPerPage,
  handlePaginationChangeEvent,
  currentPage,
  getPageHref
}: Readonly<IPaginationProps>) {
  const theme = useTheme();
  const count = getPaginationCount(totalBlogs, countPerPage);
  return <Pagination count={count} shape="rounded" size="large" sx={getPaginationStyles(theme)} renderItem={getPaginationRenderItem(getPageHref)} onChange={handlePaginationChangeEvent} page={currentPage} data-sentry-element="Pagination" data-sentry-component="BlogListPagination" data-sentry-source-file="BlogListPagination.tsx" />;
}